// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-table-main tr {
  border: none !important;
}

.dynamic-table-main td {
  border: none !important;
}

.dynamic-table-main thead {
  border: none !important;
}

.dynamic-table-main th {
  border: none !important;
}

.dynamic-table-main tbody {
  border: none !important;
}

.dynamic-table-main thead {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  background-color: #fff !important;
  z-index: 1 !important;
}

.dynamic-table-main .sticky-head {
  position: sticky;
  top: 0;
  z-index: 1;
}

.dynamic-table-main .sticky-head-border:not(:first-child):not(:last-child) {
  box-shadow: 1px 0 0 0 #e0e0e0 inset !important;
  /* Mimicking a right border on middle headers */
}

.dynamic-table-main .non-sticky-head-border {
  box-shadow: 1px 0 0 0 #e0e0e0 inset !important;
  /* Mimicking a right border on middle headers */
}

.dynamic-table-main .non-sticky-head {
  border-bottom: #e0e0e0 1px solid !important;
}

.dynamic-table-main tbody tr:first-child {
  border-top: none !important;
}

.dynamic-table-main tbody tr {
  background-color: #fff !important;
  border-width: 1px 0 1px 0 !important;
  border-color: #e0e0e0 !important;
  border-style: solid !important;
}

.dynamic-table-main td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dynamic-table-main .table tr:last-child {
  border-bottom: none !important;
}

.dynamic-table-main .table tbody tr:first-child {
  border-top: none !important;
}

.table-custom {
  border-radius: 6px;
  background-color: #fff !important;
  border-width: 1px;
  border-color: #e0e0e0;
  border-style: solid;
}

.dynamic-table-main .sticky-right {
  position: sticky;
  right: 0;
}

.dynamic-table-main .sticky-color {
  background-color: #fff !important;
}

.dynamic-table-main .sticky-color-checked {
  background-color: #daecfb !important;
}

.dynamic-table-main .sticky-left {
  position: sticky;
  left: 0;
}

.dynamic-table-main .sticky-right::before {
  content: "";
  position: absolute;
  left: 0px;
  /* Adjust this to position the shadow slightly to the left */
  top: 0;
  bottom: 0;
  width: 8px;
  /* Width can be adjusted to control the spread of the shadow */
  box-shadow: -3px 0 5px -2px rgba(0, 0, 0, 0.1);
  /* Box shadow to mimic a border effect */
  z-index: 1;
}

.dynamic-table-main .sticky-left::before {
  content: "";
  position: absolute;
  right: 0px;
  /* Adjust this to position the shadow slightly to the right */
  top: 0;
  bottom: 0;
  width: 6px;
  /* Width can be adjusted to control the spread of the shadow */
  box-shadow: 3px 0 5px -2px rgba(0, 0, 0, 0.3);
  /* Box shadow to mimic a border effect */
  z-index: 1;
}

.dynamic-table-main .row-selected {
  background-color: #daecfb !important;
}

.dynamic-table-font-size {
  font-size: 12px;
}

@media (min-width: 1024px) {
  .dynamic-table-font-size {
    font-size: 12px;
  }

  .pagination-arrow-size {
    font-size: 16px;
  }
}
@media (min-width: 1366px) {
  .dynamic-table-font-size {
    font-size: 12px;
  }

  .pagination-arrow-size {
    font-size: 16px;
  }
}
@media (min-width: 1920px) {
  .dynamic-table-font-size {
    font-size: 14px;
  }

  .pagination-arrow-size {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicTable/DynamicTable.scss"],"names":[],"mappings":"AAYA;EACE,uBAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,wCAAA;EACA,iCAAA;EACA,qBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AAXF;;AAcA;EACE,8CAAA;EAAgD,+CAAA;AAVlD;;AAaA;EACE,8CAAA;EAAgD,+CAAA;AATlD;;AAYA;EACE,2CAAA;AATF;;AAaA;EACE,2BAAA;AAVF;;AAaA;EACE,iCAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;AAVF;;AAaA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAVF;;AAcA;EACE,8BAAA;AAXF;;AAeA;EACE,2BAAA;AAZF;;AAeA;EACE,kBAAA;EACA,iCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,QAAA;AAZF;;AAiBA;EACE,iCAAA;AAdF;;AAiBA;EACE,oCAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,OAAA;AAdF;;AAkBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EAAW,4DAAA;EACX,MAAA;EACA,SAAA;EACA,UAAA;EAAY,8DAAA;EAEZ,8CAAA;EAAgD,wCAAA;EAChD,UAAA;AAbF;;AAgBA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EAAY,6DAAA;EACZ,MAAA;EACA,SAAA;EACA,UAAA;EAAY,8DAAA;EACZ,6CAAA;EAA+C,wCAAA;EAC/C,UAAA;AAVF;;AAaA;EACE,oCAAA;AAVF;;AAaA;EACE,eAAA;AAVF;;AAaA;EACE;IACE,eAAA;EAVF;;EAaA;IACE,eAAA;EAVF;AACF;AAaA;EACE;IACE,eAAA;EAXF;;EAcA;IACE,eAAA;EAXF;AACF;AAcA;EACE;IACE,eAAA;EAZF;;EAeA;IACE,eAAA;EAZF;AACF","sourcesContent":["// .table-card th {\n//   white-space: nowrap;\n//   overflow: hidden;\n//   text-overflow: ellipsis;\n// }\n\n// .table-card td {\n//   white-space: nowrap;\n//   overflow: hidden;\n//   text-overflow: ellipsis;\n// }\n\n.dynamic-table-main tr {\n  border: none !important;\n}\n\n.dynamic-table-main td {\n  border: none !important;\n}\n\n.dynamic-table-main thead {\n  border: none !important;\n}\n\n.dynamic-table-main th {\n  border: none !important;\n}\n\n.dynamic-table-main  tbody {\n  border: none !important;\n}\n\n.dynamic-table-main  thead {\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);\n  background-color: #fff !important;\n  z-index: 1 !important;\n}\n\n.dynamic-table-main  .sticky-head {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.dynamic-table-main .sticky-head-border:not(:first-child):not(:last-child) {\n  box-shadow: 1px 0 0 0 #e0e0e0 inset !important; /* Mimicking a right border on middle headers */\n}\n\n.dynamic-table-main .non-sticky-head-border {\n  box-shadow: 1px 0 0 0 #e0e0e0 inset !important; /* Mimicking a right border on middle headers */\n}\n\n.dynamic-table-main  .non-sticky-head {\n  border-bottom: #e0e0e0 1px solid !important;\n}\n\n// First tbody tr no border-top\n.dynamic-table-main  tbody tr:first-child {\n  border-top: none !important;\n}\n\n.dynamic-table-main  tbody tr {\n  background-color: #fff !important;\n  border-width: 1px 0 1px 0 !important;\n  border-color: #e0e0e0 !important;\n  border-style: solid !important;\n}\n\n.dynamic-table-main td {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// Table last row no border-bottom\n.dynamic-table-main .table tr:last-child {\n  border-bottom: none !important;\n}\n\n// Tablebody first tr no border-top\n.dynamic-table-main .table tbody tr:first-child {\n  border-top: none !important;\n}\n\n.table-custom {\n  border-radius: 6px;\n  background-color: #fff !important;\n  border-width: 1px;\n  border-color: #e0e0e0;\n  border-style: solid;\n}\n\n.dynamic-table-main .sticky-right {\n  position: sticky;\n  right: 0;\n  // background-color: white !important; /* Ensures the cell background isn't transparent */\n  // border-bottom: 2px solid #e0e0e0 !important;\n}\n\n.dynamic-table-main .sticky-color {\n  background-color: #fff !important;\n}\n\n.dynamic-table-main .sticky-color-checked {\n  background-color: #daecfb !important;\n}\n\n.dynamic-table-main .sticky-left {\n  position: sticky;\n  left: 0;\n  // background-color: white !important; /* Ensures the cell background isn't transparent */\n}\n\n.dynamic-table-main .sticky-right::before {\n  content: \"\";\n  position: absolute;\n  left: 0px; /* Adjust this to position the shadow slightly to the left */\n  top: 0;\n  bottom: 0;\n  width: 8px; /* Width can be adjusted to control the spread of the shadow */\n  // box-shadow: -3px 0 5px -2px rgba(0, 0, 0, 0.3); /* Box shadow to mimic a border effect */\n  box-shadow: -3px 0 5px -2px rgba(0, 0, 0, 0.1); /* Box shadow to mimic a border effect */\n  z-index: 1;\n}\n\n.dynamic-table-main .sticky-left::before {\n  content: \"\";\n  position: absolute;\n  right: 0px; /* Adjust this to position the shadow slightly to the right */\n  top: 0;\n  bottom: 0;\n  width: 6px; /* Width can be adjusted to control the spread of the shadow */\n  box-shadow: 3px 0 5px -2px rgba(0, 0, 0, 0.3); /* Box shadow to mimic a border effect */\n  z-index: 1;\n}\n\n.dynamic-table-main .row-selected {\n  background-color: #daecfb !important;\n}\n\n.dynamic-table-font-size {\n  font-size: 12px;\n}\n\n@media (min-width: 1024px) {\n  .dynamic-table-font-size {\n    font-size: 12px;\n  }\n\n  .pagination-arrow-size {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .dynamic-table-font-size {\n    font-size: 12px;\n  }\n\n  .pagination-arrow-size {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .dynamic-table-font-size {\n    font-size: 14px;\n  }\n\n  .pagination-arrow-size {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
